
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from "@apollo/client/react";
import Comunicado from './Comunicado';
import { GET_COMUNICADOS_ACTIVOS, adaptComunicadosActivos } from '../../../data/graphQL/queries/Comunicados/getComunicadosActivos';

export const Comunicados = () => {
    const [comunicados, setComunicados] = useState([]);
    const idUsuario = useMemo(() => (parseInt(sessionStorage.getItem('idUsuario'), 10)), [sessionStorage.getItem('idUsuario')]);

    const { data: dataComunicados } = useQuery(GET_COMUNICADOS_ACTIVOS, {
        skip: !idUsuario || isNaN(idUsuario),
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (dataComunicados?.comunicadosActivos) {
            setComunicados(adaptComunicadosActivos(dataComunicados.comunicadosActivos));
            sessionStorage.setItem('noEjecutoComunicados', 'true');
        }
    }, [dataComunicados]);

    const handleCloseComunicado = () => {
        setComunicados(prev => {
            const newComunicados = prev.slice(1);
            
            if(newComunicados <= 0) 
                sessionStorage.setItem('noEjecutoComunicados', 'false');

            return newComunicados;
        });
    }

    return (
        <>
            {comunicados.length > 0 && (
                <Comunicado
                    key={comunicados[0].idComunicado}
                    open={true}
                    onClose={() => handleCloseComunicado()}
                    tipo={comunicados[0].tipo}
                    titulo={comunicados[0].titulo}
                    mensaje={comunicados[0].mensaje}
                />
            )}
        </>
    );
}